<template>
  <b-modal
    :visible="visible"
    hide-footer
    button-size="sm"
    size="lg"
    modal-cancel="false"
    no-close-on-backdrop
    @close="close"
    id="course-syllabus-add-modal"
  >
    <template v-slot:modal-title>Añadir curso al pensum</template>
    <section class="container-fluid">
      <ValidationObserver ref="form" v-slot="{ invalid }">
        <form @submit.prevent="add">
          <section class="row">
            <!-- Curso -->
            <div class="col">
              <div class="form-group required">
                <ValidationProvider
                  name="course_id"
                  rules="required"
                  v-slot="{ valid, errors }"
                >
                  <label class="control-label" for="course_id">Curso</label>
                  <v-select
                    :options="coursesOptions"
                    label="name"
                    :reduce="(courses) => courses.id"
                    v-model="courseSyllabus.course_id"
                  ></v-select>
                  <b-form-invalid-feedback :state="valid">{{
                    errors[0]
                  }}</b-form-invalid-feedback>
                </ValidationProvider>
              </div>
            </div>
          </section>

          <b-button type="button" size="sm" variant="danger" @click="close">
            <CIcon size="sm" name="cil-x-circle" /> Cancelar
          </b-button>

          <button
            type="submit"
            class="btn btn-success btn-sm float-right"
            variant="success"
            :disabled="invalid || addLoader"
          >
            <span v-if="!addLoader">
              <CIcon size="sm" name="cil-save" /> Guardar
            </span>
            <span v-if="addLoader">
              Cargando
              <CSpinner color="success" size="sm" />
            </span>
          </button>
        </form>
      </ValidationObserver>
    </section>
  </b-modal>
</template>
<script>
import {
  BFormInvalidFeedback,
  BFormSelect,
  BFormSelectOption,
  BModal,
  BButton,
} from "bootstrap-vue";
import { Utils } from "@/plugins/utils";
import { extend } from "vee-validate";
import { required, max } from "vee-validate/dist/rules";
//services
import CoursesSyllabus from "@/plugins/services/courses-syllabus";
import Courses from "@/plugins/services/courses";

export default {
  name: "CourseSyllabusAddModal",
  components: {
    BFormInvalidFeedback,
    BFormSelect,
    BFormSelectOption,
    BModal,
    BButton,
  },
  props: {
    modShowCourseSyllabusAdd: { type: Boolean, required: true },
    syllabus_id: { type: Number, required: true },
  },
  data() {
    return {
      courseSyllabus: {
        enabled: true,
      },
      addLoader: false,
      coursesOptions: [],
      dataEmit: { modalShow: false, data: null, status: 200 },
    };
  },
  computed: {
    computedForm() {
      return this.$refs.form;
    },
    userAuth() {
      return this.$store.state.userAuth;
    },
    visible() {
      return this.modShowCourseSyllabusAdd;
    },
  },
  mounted() {
    this.addLoader = false;
    this.getCourses();
  },
  created() {
    extend("required", {
      ...required,
      message: "Este campo es requerido",
    });

    extend("max", {
      ...max,
      params: ["length"],
      message: "El campo debe tener {length} caracteres como máximo.",
    });
  },
  methods: {
    add() {
      this.addLoader = true;
      this.courseSyllabus.created_by = this.userAuth.username;
      this.courseSyllabus.syllabus_id = this.syllabus_id;
      CoursesSyllabus.add(this.courseSyllabus)
        .then((res) => {
          this.addLoader = false;
          if (res.data.success) {
            Utils.setFlash("success", res.data.message);
            this.closeModal(res.data.data);
          } else {
            Utils.setFlash("danger", res.data.message);
            this.closeModal();
          }
        })
        .catch((err) => {
          this.addLoader = false;
          if (err.response && err.response.status == 422) {
            this.$refs.form.setErrors(err.response.data.errors);
          }
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Item no encontrado.");
            this.closeModal(null, 404);
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error al crear(500).");
            this.closeModal(null, 500);
          }
        });
    },
    getCourses() {
      Courses.selectAllWithOutSyllabus({ syllabus_id: this.syllabus_id })
        .then((res) => {
          this.coursesOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    closeModal(data = null, status = 200) {
      this.courseSyllabusAddModal = {};
      this.dataEmit.modalShow = false;
      this.dataEmit.data = data;
      this.dataEmit.status = status;
      this.$emit("courseSyllabusAddModal", this.dataEmit);
    },
    close() {
      this.closeModal();
    },
  },
};
</script>
